import React from 'react';
import * as Icons from 'lucide-react';
import { FEATURES, SHOWROOM_IMAGES } from '../mock';

export default function WhyChooseUs() {
  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-28">
          <div className="inline-flex items-center gap-2 bg-black text-white px-3.5 py-1.5 rounded-full text-[11px] tracking-[0.18em] uppercase font-semibold">
            Why Timeless
          </div>
          <h2 className="font-display mt-5 text-[36px] sm:text-[48px] lg:text-[56px] font-black leading-[1.02] tracking-tight text-black">
            Buying a used car, <span className="text-[#e11d2c]">without the doubt</span>.
          </h2>
          <p className="mt-5 text-black/65 text-[15px] leading-relaxed">
            We exist because we know the anxiety that comes with buying pre-owned. Every Timeless vehicle goes through a 120-point check before it ever reaches our showroom — so you focus on the drive, not the doubts.
          </p>

          <div className="mt-8 relative aspect-[4/3] rounded-2xl overflow-hidden">
            <img src={SHOWROOM_IMAGES[0]} alt="Showroom" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
            <div className="absolute bottom-5 left-5 text-white">
              <div className="text-[10px] tracking-[0.22em] uppercase font-semibold opacity-80">Our Showroom</div>
              <div className="font-display text-[22px] font-bold">May Pen, Clarendon</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
          {FEATURES.map((f, i) => {
            const Icon = Icons[f.icon] || Icons.Star;
            return (
              <div key={i} className="group bg-white border border-black/10 rounded-2xl p-6 hover:border-[#e11d2c]/40 transition-all hover:-translate-y-1 hover:shadow-[0_24px_48px_-24px_rgba(225,29,44,0.25)]">
                <div className="w-12 h-12 grid place-items-center rounded-xl bg-black text-white group-hover:bg-[#e11d2c] transition-colors">
                  <Icon size={20} />
                </div>
                <div className="font-display text-[18px] font-bold mt-5 text-black">{f.title}</div>
                <p className="text-[13px] text-black/60 mt-2 leading-relaxed">{f.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
